import { createInput, createFormActions } from ":ui/form";

// "kha.kat@hotmail.com"
export function createValidateInputs() {
  const Email = createInput(null, {
    required: true,
  });
  const Actions = createFormActions({ Email });
  return {
    Actions,
    Email,
  };
}
